import { render } from "./NativeTabNavigatoLayout.vue?vue&type=template&id=5d211614"
import script from "./NativeTabNavigatoLayout.vue?vue&type=script&lang=js"
export * from "./NativeTabNavigatoLayout.vue?vue&type=script&lang=js"

import "./NativeTabNavigatoLayout.vue?vue&type=style&index=0&id=5d211614&lang=scss"

import exportComponent from "/builds/root/lvgou_pub_mob/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__